// export const baseUrl = "https://api-youga.jzmaxx.com";
export const baseUrl = "https://api.sunkissyogi.com";

